import { render, staticRenderFns } from "./event-form-page.vue?vue&type=template&id=6d1c9c42&"
import script from "./event-form-page.vue?vue&type=script&lang=js&"
export * from "./event-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports